import { render, staticRenderFns } from "./q-text.vue?vue&type=template&id=3630a085&scoped=true&"
import script from "./q-text.vue?vue&type=script&lang=js&"
export * from "./q-text.vue?vue&type=script&lang=js&"
import style0 from "./q-text.vue?vue&type=style&index=0&id=3630a085&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3630a085",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yangxinyuan/vhall/vhall_questionnaire_service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3630a085')) {
      api.createRecord('3630a085', component.options)
    } else {
      api.reload('3630a085', component.options)
    }
    module.hot.accept("./q-text.vue?vue&type=template&id=3630a085&scoped=true&", function () {
      api.rerender('3630a085', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questionnaire/q-text.vue"
export default component.exports